export default __webpack_public_path__ + "static/media/vertical line.9be0ea2f.svg";